import React from 'react';
import { IconProps } from './types';

const CallsAttemptedPhoneIcon: React.FC<IconProps> = props => {
  const { width = '56', height = '56', fillColor = '#E5F8EB' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.5125 55.75C45.8833 55.75 39.4217 54.2721 33.1276 51.3162C26.8314 48.3623 21.2557 44.4568 16.4005 39.5995C11.5432 34.7443 7.63767 29.1686 4.68383 22.8724C1.72794 16.5783 0.25 10.1167 0.25 3.4875C0.25 2.5625 0.558333 1.79167 1.175 1.175C1.79167 0.558333 2.5625 0.25 3.4875 0.25H15.975C16.6944 0.25 17.3368 0.48125 17.9021 0.94375C18.4674 1.40625 18.8014 1.99722 18.9042 2.71667L20.9083 13.5083C21.0111 14.2278 20.9988 14.8825 20.8713 15.4724C20.7418 16.0644 20.4458 16.5917 19.9833 17.0542L12.5833 24.6083C14.7417 28.3083 17.4396 31.7771 20.6771 35.0146C23.9146 38.2521 27.4861 41.0528 31.3917 43.4167L38.6375 36.1708C39.1 35.7083 39.7043 35.3609 40.4505 35.1287C41.1946 34.8984 41.9264 34.8347 42.6458 34.9375L53.2833 37.0958C54.0028 37.25 54.5937 37.5964 55.0562 38.1349C55.5187 38.6755 55.75 39.3056 55.75 40.025V52.5125C55.75 53.4375 55.4417 54.2083 54.825 54.825C54.2083 55.4417 53.4375 55.75 52.5125 55.75Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default CallsAttemptedPhoneIcon;
